/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import L from "../Lang"
import BaseCom from "../BaseCom";
import DataTable from "../DataTable";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";

class PanelTargetManageList extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.fillList('/api/target/list', 'list');
        SidebarGlobal.setSubNav(<>
            <button className="btn btn-primary" onClick={() => this.props.navigate('/target/manage/new')}><Icon icon="faPlus" /> <span className="d-none d-md-inline"><L>New</L></span></button>
        </>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    onSort = () => {
    }

    render() {
        const columns = [
            { name: 'edit', title: '', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit"><Icon icon="faPencil" /></Link>, width: '25px' },
            { name: 'id', title: 'ID', width: '50px', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit">{row.id}</Link> },
            { name: 'name', title: 'Name', valueFunc: (row) => <Link to={`/target/manage/${row.id}`} title="Edit">{row.name}</Link> },
            { name: 'code', title: 'Code' },
            { name: 'active', title: 'Active', valueFunc: (row) => row.isDisabled ? 'No' : 'Yes' }
        ];

        return <div className="container-fluid vh-expand">
            <h1><L>Manage Panel Targets</L></h1>
            <DataTable columns={columns} data={this.state.list} totalCount={this.state.totalCount} headClassName="--bg-primary" loading={this.state.loading} onSort={this.onSort} showCheckboxes={this.state.showFilters} defaultSort="name" defaultSortDesc />

        </div>;
    }
}

export default withParamsAndNavigate(PanelTargetManageList);